module.exports = __webpack_public_path__ + "static/simon-8826d216878b0d765f3c1cafdff5e891.webp";